<template>
  <ToastContainer ref="toastRef" />
  <router-view />
</template>

<script setup>
import { ref, onMounted, provide } from 'vue'
import { useAuthStore } from './stores/auth'
import { ToastContainer } from './components/common'

const authStore = useAuthStore()
const toastRef = ref(null)

provide('toast', toastRef)

onMounted(async () => {
  const token = localStorage.getItem('va_token')
  if (token) {
    await authStore.fetchUser()
  }

  // Initialize Reverb presence channel to establish WebSocket connection -
  // only when actually logged in. This previously ran unconditionally
  // (guarded only by `window.Echo` existing, which is always true), so a
  // logged-out visit to the app always attempted - and always failed - an
  // authorized channel join with no token at all.
  if (token && window.Echo) {
    try {
      const clientId = 'client_' + Math.random().toString(36).substr(2, 9)
      localStorage.setItem('reverb_client_id', clientId)

      // .join() (not .channel()) is required to get a PresenceChannel with
      // .here()/.joining()/.leaving() - .channel() returns a plain public
      // Channel, which has none of those. The name here ('app') must match
      // the Broadcast::channel('app', ...) authorizer in channels.php; Echo
      // already prefixes presence channels with 'presence-' on the wire, so
      // 'presence.app' here previously doubled that prefix too.
      window.Echo.join('app').here((users) => {
        console.log('[Reverb] Presence channel connected, users:', users.length)
      }).joining((user) => {
        console.log('[Reverb] User joined:', user.name)
      }).leaving((user) => {
        console.log('[Reverb] User left:', user.name)
      })

      // Report connection to backend
      fetch('/api/v1/reverb/report-connection', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ client_id: clientId, action: 'connect' })
      }).catch(err => console.error('[Reverb] Failed to report connection:', err))

      console.log('[Reverb] Presence channel listener established')
    } catch (error) {
      console.error('[Reverb] Failed to initialize presence channel:', error)
    }
  }
})
</script>
